export const faqsPl = [
  {
    q: "Kiedy warto zrobić audyt elektroniki i firmware?",
    a: "Przed skalowaniem produkcji, zmianą dostawcy, rundą inwestycyjną, problemami z baterią/stabilnością albo gdy dostaliście kod i schemat „w spadku” i nie wiecie, co jest ryzykiem.",
  },
  {
    q: "Co obejmuje audyt?",
    a: "Przegląd schematu/PCB (tam gdzie dostępne), kodu firmware, architektury komunikacji, bezpieczeństwa aktualizacji OTA, jakości testów oraz listy ryzyk z priorytetami i planem napraw.",
  },
  {
    q: "Czy audyt wymaga NDA i dostępu do kodu?",
    a: "Tak — zwykle podpisujemy NDA, potem dostajemy repozytorium, dokumentację i ewentualnie egzemplarz urządzenia. Bez tego audyt byłby powierzchowny.",
  },
  {
    q: "Ile trwa typowy audyt embedded?",
    a: "Wąski przegląd (1–2 obszary) to często 1–2 tygodnie. Szerszy audyt elektroniki + firmware + procesu releasu — zwykle 2–4 tygodnie.",
  },
  {
    q: "Czy po audycie możecie przejąć rozwój?",
    a: "Tak. Część klientów zamawia audyt jako wejście we współpracę — potem realizujemy plan napraw, OTA, refaktoryzację albo dokończenie produktu.",
  },
  {
    q: "Czy audytujecie też aplikację mobilną i cloud przy produkcie IoT?",
    a: "Możemy rozszerzyć zakres o warstwę app/backend, jeśli problem leży na styku urządzenia i oprogramowania — to częsty scenariusz w produktach connected.",
  },
  {
    q: "Czym różni się audyt od zwykłej konsultacji?",
    a: "Konsultacja odpowiada na konkretne pytanie. Audyt daje ustrukturyzowany raport: ryzyka, dowody, rekomendacje i szacunek prac naprawczych.",
  },
  {
    q: "Ile kosztuje audyt elektroniki i firmware?",
    a: "Zależy od wielkości kodu, dostępności dokumentacji i tego, czy badamy też PCB. Po krótkiej rozmowie podajemy stałą wycenę zakresu.",
  },
] as const;
